<script>

</script>
<header>
    <h1>
        <img src="/img/logo.webp" alt="logo">
    </h1>
</header>
<style>
    header{
        text-align: center;
        margin: 0;
    }
    h1{
        background-color: #fff8ed;
        margin: 0;
    }
    img{
        max-width: 180px;
    }
</style>